import {handleActions} from 'redux-actions'
import {UserExceptionType} from "./constants";

const reducerGenerator = ({
    actions: {
        ENABLED_SET,
        MINIMAL_VALUE_SET,
        USER_EXCEPTION_TYPE_SET,
        EXCEPTION_USERS_SET,
    },
    initialState
}) => {
    const initState = initialState || {
        enabled: false,
        minimalValue: false,
        userExceptionType: UserExceptionType.NoException,
        exceptionUsers: {
            all: false,
            userIds: [],
            groupIds: [],
            groupType: null,
        }
    }

    return handleActions({
        [ENABLED_SET]: (state, {payload: enabled}) => ({...state, enabled}),
        [MINIMAL_VALUE_SET]: (state, {payload: minimalValue}) => ({...state, minimalValue}),
        [USER_EXCEPTION_TYPE_SET]: (state, {payload: userExceptionType}) => ({...state, userExceptionType}),
        [EXCEPTION_USERS_SET]: (state, {payload: exceptionUsers}) => ({...state, exceptionUsers})

    }, initState)
}


export default reducerGenerator


// WEBPACK FOOTER //
// ./web/js/administration/lowBalanceSettings/reducerGenerator.js